import { Paper, Typography, Button } from '@material-ui/core'

import * as React from 'react'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import { Page } from '../../components'
import { getAuth } from '../../store/Auth/selectors'
import { Auth, State } from '../../types'
import { login } from '../Firebase/operations'
import LoginForm from '../LoginForm/'
import config from '../../config'

type Props = {
  login: () => void
  auth: Auth
}

const LoginPage: React.SFC<Props> = props => {
  if (!props.auth.loading && props.auth.authorized) {
    return <Redirect to={'/'} />
  }
  return (
    <div>
      {props.auth.loading && <span>loading</span>}
      {!props.auth.loading && (
        <Page>
          <Paper>
            <section>
              <Typography variant="h4">{config.title}</Typography>
              <Button onClick={() => props.login()}>
                Google アカウントでログイン
              </Button>
              <LoginForm />
            </section>
          </Paper>
        </Page>
      )}
    </div>
  )
}

const ms = (state: State) => ({ auth: getAuth(state) })

const conn = connect(ms, { login })

export default conn(LoginPage)
